//# sourceMappingURL=options.mjs.map
/// <reference types="./options.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

export class AutocloseBool extends $CustomType {
  constructor(boolean) {
    super();
    this.boolean = boolean;
  }
}
export const Autoclose$AutocloseBool = (boolean) => new AutocloseBool(boolean);
export const Autoclose$isAutocloseBool = (value) =>
  value instanceof AutocloseBool;
export const Autoclose$AutocloseBool$boolean = (value) => value.boolean;
export const Autoclose$AutocloseBool$0 = (value) => value.boolean;

export class AutocloseTimeout extends $CustomType {
  constructor(timeout) {
    super();
    this.timeout = timeout;
  }
}
export const Autoclose$AutocloseTimeout = (timeout) =>
  new AutocloseTimeout(timeout);
export const Autoclose$isAutocloseTimeout = (value) =>
  value instanceof AutocloseTimeout;
export const Autoclose$AutocloseTimeout$timeout = (value) => value.timeout;
export const Autoclose$AutocloseTimeout$0 = (value) => value.timeout;

export class CloseButtonBool extends $CustomType {
  constructor(boolean) {
    super();
    this.boolean = boolean;
  }
}
export const CloseButton$CloseButtonBool = (boolean) =>
  new CloseButtonBool(boolean);
export const CloseButton$isCloseButtonBool = (value) =>
  value instanceof CloseButtonBool;
export const CloseButton$CloseButtonBool$boolean = (value) => value.boolean;
export const CloseButton$CloseButtonBool$0 = (value) => value.boolean;

export class CloseButtonNode extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const CloseButton$CloseButtonNode = ($0) => new CloseButtonNode($0);
export const CloseButton$isCloseButtonNode = (value) =>
  value instanceof CloseButtonNode;
export const CloseButton$CloseButtonNode$0 = (value) => value[0];

/**
 * "x" or "y"
 */
export class DraggableDirection extends $CustomType {
  constructor(axis) {
    super();
    this.axis = axis;
  }
}
export const DraggableDirection$DraggableDirection = (axis) =>
  new DraggableDirection(axis);
export const DraggableDirection$isDraggableDirection = (value) =>
  value instanceof DraggableDirection;
export const DraggableDirection$DraggableDirection$axis = (value) => value.axis;
export const DraggableDirection$DraggableDirection$0 = (value) => value.axis;

export class Theme extends $CustomType {
  constructor(value) {
    super();
    this.value = value;
  }
}
export const Theme$Theme = (value) => new Theme(value);
export const Theme$isTheme = (value) => value instanceof Theme;
export const Theme$Theme$value = (value) => value.value;
export const Theme$Theme$0 = (value) => value.value;
